import React, { useEffect, useRef, useState } from 'react';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const Grid = ({ grid, length, height, handleFocus, handleBlur, handleKeyUp, handleChange, 
// handleToPDF,
handlePrint, }) => {
    const divRef = useRef(null);
    const [unit, setUnit] = useState(0);
    useEffect(() => {
        if (divRef.current) {
            const rect = divRef.current.getBoundingClientRect();
            setUnit(Math.floor(Math.min((rect.width - 10) / length, (rect.height - 10) / height)));
        }
    }, []);
    return (React.createElement("div", { className: "app-container" },
        React.createElement("div", { className: "app-content" },
            React.createElement("div", { id: "crossword-grid-container", className: "crossword-grid-container" },
                React.createElement("div", { ref: divRef, id: "crossword-grid", style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        padding: '5px',
                    } }, grid.map((row, i) => (React.createElement("div", { key: i, style: {
                        display: 'flex',
                        flexDirection: 'row',
                        padding: 0,
                        margin: 0,
                    } }, row.map((cell, j) => cell.type === 'blank' ? (React.createElement("div", { key: j, className: i !== 0 &&
                        i !== height - 1 &&
                        j !== 0 &&
                        j !== length - 1 &&
                        grid[i + 1][j].type === 'word' &&
                        grid[i - 1][j].type === 'word' &&
                        grid[i][j + 1].type === 'word' &&
                        grid[i][j - 1].type === 'word'
                        ? 'crossword-cell-filled'
                        : 'crossword-cell-empty', style: {
                        width: unit,
                        height: unit,
                    } })) : (React.createElement("div", { className: "crossword-cell-input", style: { width: unit, height: unit } },
                    React.createElement("fieldset", { key: j, style: {
                            border: 'none',
                            position: 'relative',
                            margin: 0,
                            padding: 0,
                            height: '100%',
                            width: '100%',
                        } },
                        React.createElement("legend", { style: {
                                position: 'absolute',
                                fontSize: unit / 4,
                                top: '2px',
                                left: '2px',
                                margin: 0,
                                padding: 0,
                                zIndex: '999',
                            } }, cell.hintNumber),
                        React.createElement("input", { id: i + '-' + j, key: j, type: "text", autoComplete: "off", className: "input", style: {
                                width: unit,
                                height: unit,
                                fontSize: unit / 2,
                            }, maxLength: 1, onKeyUp: (e) => {
                                handleKeyUp(e, cell);
                            }, onChange: (e) => {
                                handleChange(e, cell);
                            }, onFocus: (e) => {
                                handleFocus(e, cell);
                            }, onBlur: (e) => {
                                handleBlur(e, cell);
                            } }))))))))))),
        React.createElement("div", { className: "app-controls" },
            React.createElement("button", { className: "btn--secondary grid-control", onClick: handlePrint },
                React.createElement(FontAwesomeIcon, { icon: faPrint, className: "font-awesome__container" })))));
};
export { Grid };
